import React from 'react'

import style from './style.css'

export default props => (
    <label className={style.radioScope}>
        <input
            type='radio'
            defaultChecked={props.checked}
            onChange={props.handleChange || null}
            name={props.name || null}
            style={props.style || {}}
            value={props.value || ''}
            className={style.radio}
        />
        <div />
        <div className={style.content}>
            {props.children || props.label}
        </div>
    </label>
)


// WEBPACK FOOTER //
// ./src/components/atoms/Forms/radio.js